import React from 'react';
import {BrowserRouter, useRoutes} from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header/Header";
import FullProduct from "./pages/FullProduct";
import Cart from "./pages/Cart";

const Router = () => {
    return useRoutes([
        {
            path: "/eshop", element: <Home/>,
        },
        {
            path: "/eshop/search/:query", element: <Home/>
        },
        {
            path: "/eshop/product/:id", element: <FullProduct/>
        },
        {
            path: "/eshop/cart", element: <Cart/>
        }
    ]);
};

function App() {
    return (
        <BrowserRouter>
            <Header/>
            <Router/>
        </BrowserRouter>
    );
}

export default App;
